import { call, put } from 'redux-saga/effects';
import reduceStorefrontConfiguration from '../../actions/storefront/reduceStorefrontConfiguration';
import reduceUserInterface from '../../actions/storefront/reduceUserInterface';
import { getSubfolderPrefix } from '../../utils/environment';

export default function* getStorefrontConfigurationSaga() {
    try {
        const subfolderPrefix = getSubfolderPrefix();
        const response = yield call(fetch, `${subfolderPrefix}/api/context/storefront-web-configuration`);
        const configuration = yield call([response, 'json']);
        yield put(reduceStorefrontConfiguration({ ...configuration.storefrontWebConfiguration }));
        yield put(reduceUserInterface(configuration.userInterface));
    } catch (error) {
        console.error('[StorefrontSaga] Error:', error);
        yield put(reduceStorefrontConfiguration({}));
    }
}
